
  import { bootstrap } from 'vue-gtag';
  import { mapGetters } from 'vuex';

  export default {
    middleware: ['amounts', 'feefo', 'data-for-nav'],
    data () {
      return {
        showQuoteRef: false
      };
    },
    head () {
      if (this.error) {
        this.$store.commit('pageContent/setHead', {
          link: [{ href: '/error/style.css', rel: 'stylesheet' }], title: this.error.message
        });
      }
      return {
        ...{ bodyAttrs: { class: '' }, title: this.$t('title'), titleTemplate: '%s | bonkers.ie' },
        ...this.pageHead
      };
    },
    computed: {
      ...mapGetters('grooveChatTeam', { grooveGetCurrentId: 'getCurrentId' }),
      ...mapGetters('jumbotron', { jumbotron: 'getJumbotron' }),
      ...mapGetters('pageContent', { legacyJumbotron: 'getJumbotron', pageHead: 'getHead' }),
      ...mapGetters('utils', { meta: 'getMeta' }),
      environment () {
        return this.$config.environment;
      },
      error () {
        return this.$nuxt.nuxt.err;
      },
      headerClass () {
        if (this.$route.path === '/') {
          return 'alternative-jumbo';
        }
        if (this.jumbotron) {
          return this.jumbotron.type || 'generic';
        } else if (this.legacyJumbotron) {
          return this.legacyJumbotron.listClass;
        }
        return null;
      }
    },
    watch: {
      '$store.state.utils.filterDisplay' (newVal, oldVal) {
        if (newVal !== oldVal) {
          document.querySelector('body').classList[oldVal ? 'remove' : 'add']('filter-fixed-view');
        }
      },
      $route () {
        this.showQuoteRef = this.$router.currentRoute.fullPath === '/compare-car-insurance/your-results/';
        this.grooveChat();
      }
    },
    beforeMount () {
      this.bindCookieConsent();
      this.setWidth();
      window.addEventListener('resize', this.setWidth);
    },
    mounted () {
      if (this.error) {
        this.$honeybadgerGeneric.addBreadcrumb('Nuxt Error', {
          category: 'error',
          metadata: {
            error: this.error
          }
        });
        this.$honeybadgerGeneric.notify(this.error);
      }
      if (this.$nuxt && this.$nuxt.$route && this.$nuxt.$route.path) {
        this.$store.dispatch('grooveChatTeam/setTeamIdFromPath', this.$nuxt.$route.path);
      }
      this.grooveChat();
    },
    methods: {
      bindCookieConsent () {
        if (this.$config.environment !== 'production') return;
        window.addEventListener('C0002-active', function () {
          this.$ga.enable();
          this.$ga.page();
          this.$gtm.init(process.env.GTM_ID);
          if (process.env.ENVIRONMENT === 'production') {
            bootstrap().then((_) => {
              this.$gtag.optIn();
              this.$gtag.set();
            });
          }
        });
      },
      setWidth () {
        this.$store.commit('utils/setWindowWidth', window.innerWidth);
      },
      grooveChat () {
        if (this.$config.environment !== 'production') return;
        this.$store.dispatch('grooveChatTeam/setTeamIdFromPath', this.$route.path);
        if (this.grooveGetCurrentId) {
          this.$groove(window, document, this.grooveGetCurrentId);
        } else if (window.groove && window.groove.widget) {
          window.groove.widget.destroy();
        }
      }
    }
  };
